export const QUEUE_MUTATION_TYPES = [
  'agents',
  'notification',
  'conversations',
  'conversationLabels',
  'conversationMetadata',
  'conversationTypingStatus',
];
